export const fireToast = (message: string) => {
    const event = document.createEvent('Event') as any;
    event.message = message;
    event.initEvent('toast_show', true, true);
    document.body.dispatchEvent(event);
}